import { isValidCents } from './cents.js'
import type { Cents } from './cents.js'

/**
 * A borda de renderização, e só ela. Dentro do app, dinheiro é `Cents`; string
 * formatada é o que a tela mostra, nunca o que o código soma.
 *
 * O formatador é criado uma vez: `Intl.NumberFormat` é caro de construir e
 * barato de reusar, e uma lista de transações chama isto uma vez por linha.
 */
const FORMATTER = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })

/**
 * `31245` vira `R$ 312,45` — com espaço **não separável** entre símbolo e
 * número, que é o que o pt-BR manda.
 *
 * **A divisão por 100 é a única do repositório e vive aqui de propósito.** É o
 * que a nota autoriza ("formatação só na borda de renderização"): o resultado
 * vai para a tela, nunca de volta para uma conta. Ela é exata para todo valor
 * abaixo de ~R$ 35 trilhões, onde o passo do double ainda é menor que um
 * centavo; acima disso o último centavo pode escorregar. Para uma casa de duas
 * pessoas (princípio 8), o limite não existe na prática.
 */
export function formatBRL(cents: Cents): string {
  if (!isValidCents(cents)) {
    throw new Error(`formatBRL: valor precisa ser inteiro em centavos, recebi ${String(cents)}`)
  }
  // `-0 === 0` é verdadeiro, então isto troca o zero negativo pelo positivo.
  // Sem a troca, `Intl` escreve "-R$ 0,00": um saldo zerado que veio de uma
  // subtração apareceria na tela como se fosse negativo.
  const reais = cents === 0 ? 0 : cents / 100
  return FORMATTER.format(reais)
}
